import { AbstractControl, ValidationErrors } from '@angular/forms';

import { isEmptyValue } from '@core/helpers/value-empty-checker.helper';
import { ControlValidatorValidationErrors } from '../models/control-validator.model';

export class RequiredValidator extends ControlValidatorValidationErrors {
  static errorKey = 'required';

  static validate(control: AbstractControl): ValidationErrors | null {
    return control.touched && isEmptyValue(control.value) ? this.validationErrors(this.errorKey, 'Value required') : null;
  }
}
